import { InjectionToken } from '@angular/core';
import { RadioButtonBaseDirective, RadioGroupBaseDirective } from '../components/radio-button/radio-base.directive';

export const RADIO_GROUP = new InjectionToken<RadioGroupBaseDirective<RadioButtonBaseDirective>>('CoreRadioGroup');
